import VM from '@src/mobx-store/vm/view-model';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import routeConfigs from '@src/pages/app-router/route-configs';
import CommonModal from '@src/business-components/common-modal';
import Services from '@src/services/general';
import reload from '@src/utils/reload';

export default class MainVM extends VM {
  static getInitialProps = async () => {
    return {};
  };

  /**
   * 页面状态
   * @type {{}}
   */
  viewState = {
    //用户名
    account: '',
    //是否有绑定手机
    isBindPhone: false,
    //绑定手机号(加密)
    bindPhone: undefined,
    //真实姓名
    realName: '',
    //身份证后6位
    idNumLastSix: '',
    //校验token（用于bind_new_phone_with_tokenA接口）
    token: undefined,
    //手机号码
    phone: '',
    //手机验证码
    code: '',
    //原手机号码
    oldPhone: undefined,
    //手机验证码
    oldPhoneCode: undefined,
    //新手机号码
    newPhone: undefined,
    //步骤-绑定手机
    stepperBind: [
      {
        title: '1.验证身份信息',
        key: 'verifyId'
      },
      {
        title: '2.绑定手机',
        key: 'bindPhone'
      },
      {
        title: '3.完成',
        key: 'complete'
      }
    ],
    //步骤-修改绑定手机
    stepperRebind: [
      {
        title: '验证身份信息',
        key: 'verifyId'
      },
      {
        title: '绑定手机',
        key: 'bindPhone'
      },
      {
        title: '完成',
        key: 'complete'
      }
    ],
    //当前执行步骤
    currentStep: 'verifyId',
    //是否验证原手机
    checkOldPhone: false
  };

  $$componentDidMount() {
    this.viewState.account = this.$rootStore.globalStore.currentAccount;
    this.getConfig();
  }

  /**
   * 推导类型
   * @type {{}}
   */
  computes = {
    // get isValid() {
    //   return Number(this.viewState.inputStore.value) > 100;
    // }
  };

  /**
   * 数据映射
   */
  mappers = {
    // /**
    //  * @this {MainVM}
    //  */
    // mapBusinessExampleNewsItems(items) {
    //   debugger;
    //   return Object.keys(items).map(key => {
    //     const item = items[key];
    //     return {
    //       des: item.description,
    //       title: item.title,
    //       onClick: () => {
    //         this.entry.onButtonClick({ id: item.id });
    //       }
    //     };
    //   });
    // }
  };

  /**
   * 入口函数
   */
  entry = {
    /**
     * 输入
     * @param type
     * @param v
     */
    onValueChange(type, v) {
      let value = v.replace(/\s+/g, '');
      switch (type) {
        case 'realName':
          this.viewState.realName = value;
          break;
        case 'idNumLastSix':
          this.viewState.idNumLastSix = value;
          break;
        case 'phone':
          this.viewState.phone = value;
          break;
        case 'code':
          this.viewState.code = value;
          break;
        default:
          break;
      }
    },
    /**
     * 提交
     * @param type
     */
    onSubmit(type) {
      let isValid = false;
      switch (type) {
        case 'verifyId':
          isValid = this.validVerifyId();
          isValid && this.verifyIdentify();
          break;
        case 'bindPhone':
          isValid = this.validVerifyPhone();
          isValid && this.bindNewPhoneWithToken();
          break;
        default:
          break;
      }
    },

    @captchaHandlerDecorate()
    async ongetPhoneCode({ ...authParams }) {
      const { phone, checkOldPhone } = this.viewState;
      await this.$ztServices
        .getPhoneCode({ phone, checkOldPhone, ...authParams })
        .then(data => {
          // console.info(token,data);
          alert('发送验证码成功');
        })
        .catch(err => {
          if (err && err.serviceResponse) {
            const errCode = err.serviceResponse.code;
            const errMsg = err.serviceResponse.message;
            alert(errMsg);
          }
        });
    },

    async onExitClick() {
      await Services.logout()
        .then(data => {
          alert('退出成功');
          reload();
          this.redirect(routeConfigs.MAIN.getFormatPath());
        })
        .catch(err => {
          const errCode = err.serviceResponse.code;
          const errMsg = err.serviceResponse.message;
          alert(errMsg);
        });
    },
    onLoginClick() {
      this.redirect(routeConfigs.LOGIN.getFormatPath({ type: 'bindPhone' }));
    }
  };

  /**
   * 校验真实姓名和身份证后6位
   * @returns {boolean}
   */
  validVerifyId() {
    let isValid = false;
    const { realName, idNumLastSix } = this.viewState;
    if (!realName) {
      alert('真实姓名不能为空');
    } else if (!idNumLastSix) {
      alert('身份证后6位不能为空');
    } else if (realName && (realName.length < 2 || realName.length > 16)) {
      alert('请输入2-16位汉字');
    } else if (idNumLastSix && idNumLastSix.length !== 6) {
      alert('请输入身份证后6位');
    } else {
      isValid = true;
    }
    return isValid;
  }

  /**
   * 校验手机号码和验证码
   * @returns {boolean}
   */
  validVerifyPhone() {
    let isValid = false;
    const { phone, code } = this.viewState;
    if (!phone) {
      alert('手机号码不能为空');
    } else if (!code) {
      alert('验证码不能为空');
    } else if (code && code.length !== 6) {
      alert('请输入6位数字');
    } else {
      isValid = true;
    }
    return isValid;
  }

  /**
   * 获取全局配置
   * @returns {Promise<void>}
   */
  async getConfig() {
    await this.$ztServices
      .getConfig()
      .then(data => {
        // console.info(data);
        const { bind_phone, is_bind_phone } = data;
        this.viewState.bindPhone = bind_phone;
        this.viewState.isBindPhone = is_bind_phone;

        if (is_bind_phone && bind_phone) {
          CommonModal.append(
            {
              desc: '您已经绑定过手机号码了，是否修改绑定手机号码？',
              onConfirmClick: () => {
                this.redirect(routeConfigs.UPDATEPHONE.getFormatPath());
              }
            },
            this.context
          );
        }
      })
      .catch(err => {
        if (err && err.serviceResponse) {
          const errCode = err.serviceResponse.code;
          if (errCode === -12816 || errCode === -13403 /*账号未登录  请先登录*/) {
            this.redirect(routeConfigs.LOGIN.getFormatPath({ type: 'bindPhone' }));
          } else {
            const errMsg = err.serviceResponse.message;
            alert(errMsg);
          }
        }
      });
  }

  /**
   * 验证真实姓名和身份证是否一致
   * @returns {Promise<void>}
   */
  async verifyIdentify() {
    const { realName, idNumLastSix } = this.viewState;
    await this.$ztServices
      .verifyIdentify(realName, idNumLastSix)
      .then(data => {
        // console.info(token,data);
        const { token } = data;
        this.viewState.token = token;
        this.viewState.realName = '';
        this.viewState.idNumLastSix = '';
        this.viewState.currentStep = 'bindPhone';
      })
      .catch(err => {
        if (err && err.serviceResponse) {
          const errCode = err.serviceResponse.code;
          if (errCode === -12816 || errCode === -13403 /*账号未登录  请先登录*/) {
            this.redirect(routeConfigs.LOGIN.getFormatPath({ type: 'bindPhone' }));
          } else {
            const errMsg = err.serviceResponse.message;
            alert(errMsg);
          }
        }
      });
  }

  /**
   * 绑定新手机(用户没有绑定过手机的情况)
   * @returns {Promise<void>}
   */
  async bindNewPhoneWithToken() {
    const { token, phone, code } = this.viewState;
    await this.$ztServices
      .bindNewPhoneWithToken(token, phone, code)
      .then(data => {
        // console.info(token,data);
        this.viewState.currentStep = 'complete';
        // alert('绑定成功');
      })
      .catch(err => {
        if (err && err.serviceResponse) {
          const errCode = err.serviceResponse.code;
          const errMsg = err.serviceResponse.message;
          if (errCode === -12816 || errCode === -13403 /*账号未登录  请先登录*/) {
            // this.redirect(routeConfigs.LOGIN.getFormatPath({ type: 'bindPhone' }));
          } else {
            alert(errMsg);
          }
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/main/vm.js